import { render, staticRenderFns } from "./elementSidebar.template.vue?vue&type=template&id=bc7e700e&scoped=true&"
var script = {}
import style0 from "./elementSidebar.template.vue?vue&type=style&index=0&id=bc7e700e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e700e",
  null
  
)

export default component.exports